import keyMirror from 'keymirror';

export const qAActionTypes = keyMirror({
	GET_QA_OVERVIEW: null,
	GET_QA_OVERVIEW_SUCCESS: null,
	GET_QA_OVERVIEW_MORE_SUCCESS: null,
	GET_QA_OVERVIEW_ERROR: null,

	CHANGE_FILTERS: null,
	GET_MY_QUESTIONS: null,
	GET_MY_QUESTIONS_SUCCESS: null,
	GET_MY_QUESTIONS_ERROR: null,

	GET_MY_ANSWERS: null,
	GET_MY_ANSWERS_SUCCESS: null,
	GET_MY_ANSWERS_ERROR: null,

	GET_HIW_RANKS: null,
	GET_HIW_RANKS_SUCCESS: null,
	GET_HIW_RANKS_ERROR: null,

	GET_QUESTION_DETAILS: null,
	GET_QUESTION_DETAILS_SUCCESS: null,
	GET_QUESTION_DETAILS_ERROR: null,
	GET_RELATED_QUESTION: null,
	GET_RELATED_QUESTION_SUCCESS: null,
	GET_RELATED_QUESTION_ERROR: null,
	SET_IS_DELETED_QUESTION: null,
	UPVOTE_ANSWER: null,
	CLEAR_QUESTION_DETAILS: null,
	CLEAN_QUESTION_STATE: null,
	CLEAN_QA_STATE: null,
});

export const getQuestionsOverviewTabs = (t) => [
	{ title: t('q_a.tabs.questions'), value: 'overview', index: 0, link: 'overview' },
	{
		title: t('q_a.tabs.my_questions'),
		value: 'my-questions',
		index: 1,
		link: 'my-questions',
	},
	{ title: t('q_a.tabs.my_answers'), value: 'my-answers', index: 2, link: 'my-answers' },
	{ title: t('q_a.tabs.hiw'), value: 'how-it-works', index: 3, link: 'how-it-works' },
];

export const getSortOptions = (t) => [
	{
		value: 'rel',
		title: t('q_a.search_filter.sort_option_1'),
	},
	{
		value: 'desc',
		title: t('q_a.search_filter.sort_option_2'),
	},
];

export const getAdminOptionIcon = (item) => {
	switch (item.id) {
		case 'answered_by_tutor':
			return 'chat-answered';
		case 'approved':
			return 'check';
		case 'flagged':
			return 'flag';
		case 'needs_quick_answer':
			return 'chat';
		case 'to_check':
			return 'search';
		case 'highlighted':
			return 'verified';
		case 'pinned':
			return 'pin';
		case 'hidden':
			return 'visibility-off';
		case 'deleted':
			return 'trash-can';
		case 'suspicious':
			return 'alert';
		default:
			return '';
	}
};
